// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-01T17:24:20.568Z
// Property: Ashton Pointe (ID: 6767906449167330)
// Collections: 18 amenities, 10 floorplans (live), 18 photos, 38 POIs, 2 reviews, 2 virtual tours, 5 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162258",
  "multihub_property_id": "6767906449167330",
  "property_external_id": "100160111",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/ashton-pointe-apartments-monroe-ga/1ct7x26/",
  "property_google_business_url": "https://www.google.com/maps/place/Ashton+Pointe/data=!4m2!3m1!1s0x0:0x891716b730797ae5?sa=X&ved=1t:2428&ictx=111https://g.co/kgs/7pJizrW",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": "5586674",
  "property_status": null,
  "property_slug": "ashton-pointe",
  "property_name": "Ashton Pointe",
  "property_website_url": "https://www.liveatashtonpointega.com/",
  "property_domain": "https://www.liveatashtonpointega.com/",
  "property_address": "429 Plaza Dr",
  "property_full_address": "429 Plaza Dr, Monroe, GA 30655",
  "property_address_1": "429 Plaza Dr",
  "property_address_2": null,
  "property_address_city": "Monroe",
  "property_address_state": "GA",
  "property_address_zip_full": null,
  "property_address_zip": "30655",
  "property_address_country": "US",
  "property_address_county": "Walton County",
  "property_neighborhood_address": "Walton County",
  "property_address_latitude": "33.7994467",
  "property_address_longitude": "-83.72821499999999",
  "property_email": "ashtonpointe@axiares.com",
  "property_phone": "(470) 570-9747",
  "property_call_tracking_phone": "866-786-5412",
  "property_company_name": "Axia Residential (ARC Living)",
  "property_company_url": "https://www.axiares.com/",
  "agency_contacts": null,
  "property_type": "Apartment",
  "property_short_description": "At Ashton Pointe in Monroe, GA, your ideal home awaits with versatile one, two, and three-bedroom floor plans. Enjoy resort-style amenities, including a sparkling swimming pool, playground, and lush landscaping. Experience convenience and comfort in a pet-friendly community that prioritizes you. Browse availability or schedule a tour today!",
  "property_long_description": "Welcome to Ashton Pointe, your ideal apartment community nestled in the heart of Monroe, GA. Our thoughtfully designed floor plans offer one-bedroom, two-bedroom, and three-bedroom options, ensuring the perfect fit for any lifestyle. At Ashton Pointe, we emphasize a maintenance-free lifestyle, allowing you to enjoy all the conveniences our community has to offer.\n\nDive into relaxation at our sparkling swimming pool, or watch your children laugh and play at our safe, well-equipped children's playground. With professional management on-site, we’re dedicated to providing a hassle-free living experience in a pet-friendly environment that feels like home.\n\nEnjoy effortless parking and beautifully landscaped grounds that complement our spacious apartments. Inside, you'll find inviting features including carpeted bedrooms, ceiling fans for comfort, wood-plank flooring that adds elegance, and all-white appliances that create a bright, fresh atmosphere. Each unit is equipped with essential amenities such as washer/dryer hookups, refrigerators, ranges, and dishwashers, ensuring your life is as convenient as possible. Plus, high-speed internet access keeps you connected whenever you need it.\n\nAshton Pointe is conveniently located, placing you close to essential shopping, dining, and entertainment options. Whether you’re looking for a cozy one-bedroom or need the extra space in a three-bedroom, Ashton Pointe has the perfect home waiting for you.\n\nDon’t wait to embrace a new chapter of comfortable living. Find your new home today—browse our availability or schedule a tour to experience the Ashton Pointe lifestyle firsthand!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d5524-e2f3-774f-a817-f866f3daf104.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior view of apartment buildings with balconies and manicured lawns.",
    "public_id": "019d5524-e2f3-774f-a817-f866f3daf104",
    "storage_key": "property/6767906449167330/019d5524-e2f3-774f-a817-f866f3daf104.webp",
    "width": 2000,
    "height": 970
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "57",
  "property_year_built": "1999",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "98.24561403508771",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Security Deposit (Refundable)\n$500.00",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "250",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "20",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Maximum of 2 pets per apartment with no weight restrictions.",
  "property_pet_policy_description": "Pet Types: Cats & Dogs\nBreed Restrictions Apply\nMaximum Pets Per Unit: 2",
  "property_petpolicy_info": "\nPet Policy\nPet Types: Cats & Dogs\n\nBreed Restrictions Apply\n\nMaximum Pets Per Unit: 2",
  "property_online_leasing_url": "https://ashtonpointeaxia.prospectportal.com/Monroe/Ashton Pointe",
  "property_resident_portal_url": "https://ashtonpointeaxia.residentportal.com/auth",
  "property_apply_now_url": "https://ashtonpointeaxia.prospectportal.com/Apartments/module/application_authentication/popup/false/kill_session/1/property/100160111/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d5524-e10d-76bd-a046-c627180a30fd.webp",
  "property_primary_logo_media": {
    "alt_text": "Ashton Pointe logo",
    "public_id": "019d5524-e10d-76bd-a046-c627180a30fd",
    "storage_key": "property/6767906449167330/019d5524-e10d-76bd-a046-c627180a30fd.webp",
    "width": 200,
    "height": 118
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019ddf7e-950d-71d3-80b1-7e644546fb34.webp",
  "property_fav_icon_media": {
    "alt_text": "Blue circle with four subtle triangle cutouts",
    "public_id": "019ddf7e-950d-71d3-80b1-7e644546fb34",
    "storage_key": "property/6767906449167330/019ddf7e-950d-71d3-80b1-7e644546fb34.webp",
    "width": 48,
    "height": 48
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d5525-10bc-733c-9589-728dc0418449.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019d5525-10bc-733c-9589-728dc0418449",
    "storage_key": "property/6767906449167330/019d5525-10bc-733c-9589-728dc0418449.webp",
    "width": 200,
    "height": 118
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d5525-03e6-7599-8a9e-ec843f522909.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019d5525-03e6-7599-8a9e-ec843f522909",
    "storage_key": "property/6767906449167330/019d5525-03e6-7599-8a9e-ec843f522909.webp",
    "width": 200,
    "height": 118
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162258/019d54d9-0a7f-7644-86f7-60a98c66fa2f.webp",
  "property_company_logo_media": {
    "alt_text": "AXIA RESIDENTIAL BY ARC logo",
    "public_id": "019d54d9-0a7f-7644-86f7-60a98c66fa2f",
    "storage_key": "company/5767906449162258/019d54d9-0a7f-7644-86f7-60a98c66fa2f.webp",
    "width": 3072,
    "height": 1849
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162258/019d54d9-c530-7559-a71a-a1a4613d29fc.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "AXIA Residential by ARC logo",
    "public_id": "019d54d9-c530-7559-a71a-a1a4613d29fc",
    "storage_key": "company/5767906449162258/019d54d9-c530-7559-a71a-a1a4613d29fc.webp",
    "width": 125,
    "height": 75
  },
  "property_primary_color": "#242424",
  "property_secondary_color": "#373737",
  "property_font_color": "#464646",
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "804 - 1200",
  "property_sqft_min": "804",
  "property_sqft_max": "1200",
  "property_price_range": "$1000 - $1661",
  "property_price_min": "1000",
  "property_price_max": "1661",
  "property_available_units": 1,
  "property_facebook_url": "https://www.facebook.com/ashtonpointeofmonroega",
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJp3rvZGfQ9YgR5Xp5MLcWF4k",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/ashton-pointe-monroe",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Ashton Pointe",
  "property_home_romance_title": "Embrace the Joy of Living in Your Dream Apartment",
  "property_home_amenities_blurb": "Welcome to Ashton Pointe in Monroe, GA, where modern living meets comfort. Choose from spacious one, two, and three-bedroom floor plans, each designed for your lifestyle. Enjoy our sparkling swimming pool, children's playground, and pet-friendly environment, all complemented by professional management and lush landscaping. A maintenance-free life awaits!",
  "property_home_floorplans_blurb": "Welcome to Ashton Pointe in picturesque Monroe, GA, where modern living meets inviting comfort. Our thoughtfully designed floor plans cater to diverse lifestyles, ensuring you'll find the perfect fit. Ready to make your move? Browse our available apartment homes and step into a world of style and convenience today!",
  "property_home_gallery_blurb": "Welcome to Ashton Pointe in Monroe, GA, where sophisticated living meets comfort. Choose from our thoughtfully designed one, two, or three-bedroom apartments, each featuring modern amenities like a sparkling pool and a children’s playground. Experience maintenance-free living in a pet-friendly community with lush landscaping. Picture yourself living here!",
  "property_home_neighborhood_blurb": "Welcome to Ashton Pointe, your gateway to life in Monroe, GA. Nestled near top-notch schools like George Walton Academy and Athens Technical College, our community offers easy access to scenic parks, recreational facilities, and charming attractions like the Monroe Museum and Hurricane Stadium. Uncover the vibrant lifestyle awaiting you!",
  "property_home_reviews_blurb": "Welcome to Ashton Pointe in Monroe, GA, where residents rave about the \"warm and welcoming atmosphere.\" Experience a community that prioritizes comfort, style, and connection. See what our residents have to say about living at our community and discover why so many call Ashton Pointe home!",
  "property_neighborhood_blurb": "Nestled in the heart of Monroe, GA, Ashton Pointe offers a vibrant community with easy access to local gems like the Monroe Museum, historic McDaniel-Tichenor House, and scenic Felker Park. Enjoy the convenience of nearby Athens Technical College and Walton Athletic 24, making it the perfect blend of comfort and activity.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Welcome to Ashton Pointe in Monroe, GA, where comfort meets convenience. Choose from spacious one, two, or three-bedroom floor plans, each crafted for a maintenance-free lifestyle. Dive into our sparkling swimming pool, unwind in lush landscapes, or enjoy high-speed internet for modern living—your ideal pet-friendly haven awaits!",
  "property_applynow_blurb": "At Ashton Pointe in Monroe, GA, your dream apartment awaits! Choose from stylish one, two, or three-bedroom floor plans, all nestled within lush landscaping. Enjoy a hassle-free lifestyle with amenities like a sparkling swimming pool, pet-friendly zones, and effortless parking. Lease online today and embrace modern living!",
  "property_contactus_blurb": "At Ashton Pointe in Monroe, GA, your ideal home awaits! Choose from our thoughtfully designed one, two, and three-bedroom floor plans that cater to your lifestyle. Each layout offers comfort and style. Have questions? Contact our leasing team today and take the first step toward your new apartment!",
  "property_faqs_blurb": "At Ashton Pointe in Monroe, GA, you'll find spacious one-, two-, and three-bedroom apartments tailored to your lifestyle. Curious about our community? Our FAQs page holds the key to your questions, guiding you through all the details of life at Ashton Pointe. Uncover the answers you seek today!",
  "property_floorplans_blurb": "At Ashton Pointe in Monroe, GA, we offer an array of stylish floor plans tailored to your lifestyle. Choose from our cozy one-bedroom, spacious two-bedroom, or expansive three-bedroom apartments. Each design combines comfort and functionality, ensuring you'll feel right at home. Browse our available apartment homes today!",
  "property_gallery_blurb": "At Ashton Pointe in Monroe, GA, vibrant living meets comfort. Choose from spacious one, two, or three-bedroom floor plans equipped with modern amenities, including a sparkling swimming pool and children’s playground. Picture yourself lounging on lush grounds, enjoying maintenance-free living, and reveling in your pet-friendly haven today!",
  "property_interactivemap_blurb": "At Ashton Pointe in Monroe, GA, choose from spacious one, two, or three-bedroom floor plans designed for comfort and style. Enjoy a maintenance-free lifestyle with amenities like a sparkling swimming pool, a playground for kids, and pet-friendly options. Use our interactive community map to find your perfect home today!",
  "property_pets_blurb": "At Ashton Pointe in Monroe, GA, your furry friends are cherished. Our pet-friendly apartments welcome up to two pets with no weight limits, ensuring every tail can wag freely. With a small move-in fee and affordable monthly pet rent, your home can be as lively as your lifestyle.",
  "property_referafriend_blurb": "At Ashton Pointe in Monroe, GA, vibrant living awaits with thoughtfully designed one, two, and three-bedroom floor plans tailored for your lifestyle. Share the joy of community—refer a friend today and enjoy the perks of great neighbors and unforgettable experiences together! Your next adventure begins here!",
  "property_residentaccess_blurb": "At Ashton Pointe in Monroe, GA, convenience meets comfort. Choose from spacious one, two, or three-bedroom floor plans that perfectly suit your lifestyle. Ready to simplify your living experience? Access your resident portal now to effortlessly pay rent, schedule maintenance, and stay connected with our vibrant community!",
  "property_reviews_blurb": "At Ashton Pointe in Monroe, GA, residents rave about the welcoming atmosphere and exceptional amenities: “Living here feels like a dream come true!” Join our vibrant community and see what your future neighbors love most about their home. Read our reviews and envision your new lifestyle today!",
  "property_created_at": "1775245286719",
  "property_scheduletour_blurb": "At Ashton Pointe in Monroe, GA, your perfect home awaits! Choose from our thoughtfully designed one, two, or three-bedroom floor plans that cater to your lifestyle. Schedule a tour today and see why our residents love calling Ashton Pointe home—your future community is just around the corner!",
  "property_thankyou_blurb": "Thank you for your interest in Ashton Pointe, Monroe's premier apartment community. With a variety of thoughtfully designed floor plans—one, two, and three bedrooms—you're sure to find the perfect home tailored to your lifestyle. Stay tuned; our team will reach out to you shortly to assist with your journey!",
  "property_virtualtours_blurb": "At Ashton Pointe in Monroe, GA, each apartment is a canvas for your lifestyle. Choose from our thoughtfully designed one, two, or three-bedroom floor plans, featuring modern amenities and inviting spaces. Ready to envision your new home? Take a virtual tour and experience the charm of our community today!",
  "property_copyright": "2026 All Rights Reserved. Ashton Pointe",
  "property_seo_title_home": "Ashton Pointe |  Apartments in Monroe, GA",
  "property_seo_description_home": "Welcome to Ashton Pointe in Monroe, GA! Enjoy spacious layouts, a sparkling pool, playgrounds, and a pet-friendly, maintenance-free lifestyle!",
  "property_seo_title_floorplans": "Floor Plans | Monroe, GA Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Ashton Pointe in Monroe, GA! Choose from stylish one, two, or three-bedroom floor plans that fit your lifestyle.",
  "property_seo_title_amenities": "Amenities | Monroe, GA Apartments for Rent",
  "property_seo_description_amenities": "Live the Ashton Pointe lifestyle in Monroe, GA—enjoy a sparkling pool, pet-friendly spaces, and modern interiors. Embrace convenience and comfort today!",
  "property_seo_title_gallery": "Gallery | Apartments in Monroe, GA",
  "property_seo_description_gallery": "At Ashton Pointe in Monroe, GA, envision your perfect home with stunning amenities, from a sparkling pool to lush landscapes. Picture yourself living here!",
  "property_seo_title_virtualtours": "Virtual Tours | Ashton Pointe Apartments",
  "property_seo_description_virtualtours": "Experience the charm of Ashton Pointe in Monroe, GA. Take a virtual tour of our one, two, and three-bedroom apartments and envision your new home today!",
  "property_seo_title_interactivemap": "Interactive Map | Ashton Pointe Apartments",
  "property_seo_description_interactivemap": "Discover your dream home at Ashton Pointe, Monroe, GA! Spacious layouts, pet-friendly community, and great amenities await. Explore now!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Monroe, GA",
  "property_seo_description_neighborhood": "Experience life at Ashton Pointe in Monroe, GA! Uncover local gems and attractions just steps from our one, two, and three-bedroom apartments.",
  "property_seo_title_contact": "Contact Us | Ashton Pointe",
  "property_seo_description_contact": "Discover Ashton Pointe in Monroe, GA! From cozy one to spacious three-bedroom layouts, we're here to help—contact us today!",
  "property_seo_title_faqs": "FAQs | Apartments in Monroe, GA",
  "property_seo_description_faqs": "Find answers about Ashton Pointe in Monroe, GA! Learn about our amenities, floor plans, and more to make the most of your pet-friendly community living.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Monroe, GA",
  "property_seo_description_reviews": "Experience life at Ashton Pointe in Monroe, GA! Dive into resident reviews and see why our vibrant community and top-notch amenities make home sweet home.",
  "property_seo_title_applynow": "Apply Now | Apartments in Monroe, GA",
  "property_seo_description_applynow": "Welcome to Ashton Pointe in Monroe, GA! Enjoy spacious floor plans, a sparkling pool, and pet-friendly living. Lease your new home online today!",
  "property_seo_title_residentaccess": "Resident Access | Ashton Pointe",
  "property_seo_description_residentaccess": "At Ashton Pointe, Monroe, GA, stay connected! Access rent payments, maintenance requests, and community updates all through your resident portal!",
  "property_seo_title_referafriend": "Refer A Friend | Ashton Pointe",
  "property_seo_description_referafriend": "Refer a friend to Ashton Pointe in Monroe, GA! Share the experience of vibrant living and create unforgettable memories together in our welcoming community!",
  "property_seo_title_scheduletour": "Schedule a Tour | Ashton Pointe",
  "property_seo_description_scheduletour": "Discover Ashton Pointe in Monroe, GA! Schedule a tour and envision your ideal life in our vibrant community with modern amenities.",
  "property_seo_title_privacy": "Privacy Policy | Ashton Pointe",
  "property_seo_description_privacy": "At Ashton Pointe in Monroe, GA, your privacy matters. Learn how we protect your data and enhance your living experience. View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Ashton Pointe",
  "property_seo_description_accessibility": "At Ashton Pointe in Monroe, GA, we're committed to digital inclusion. Join us in creating a welcoming community for everyone—online and off!",
  "property_seo_title_sitemap": "Sitemap | Ashton Pointe",
  "property_seo_description_sitemap": "Uncover the path to your ideal home at Ashton Pointe in Monroe, GA. Dive into our sitemap for a seamless journey through our vibrant apartment community!",
  "property_seo_title_thankyou": "Thank You | Ashton Pointe",
  "property_seo_description_thankyou": "Thank you for your interest in Ashton Pointe! Our team will be in touch soon to help you find your perfect home in beautiful Monroe, GA. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Monroe, GA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1790793450322",
  "amenities": [
    {
      "id": "custom_863109b4-2ef8-4dc4-80a6-f4eef1a3506f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_945c6f89-a897-488f-8e22-0bd0b8adc991",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "external_id": "false",
      "title": "Sparkling Swimming Pool",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_03ed1fe4-6142-4c2c-b0bf-2e23433ec2da",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "external_id": "false",
      "title": "Children's Playground",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_87f13e71-2731-4b66-9a03-60bb5d3086ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "external_id": "false",
      "title": "Professional Management",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9c3a803a-d75d-4537-8829-059348843093",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "external_id": "false",
      "title": "Convenient Location",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6ef453cd-5e46-442f-8d83-d29f278af4e6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "external_id": "false",
      "title": "Effortless Parking",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8d071126-d985-4408-8f00-00d3d3a31535",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "external_id": "false",
      "title": "Maintenance‑Free Lifestyle",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1c234770-8f18-464c-b03e-dc0657589db2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "external_id": "false",
      "title": "Pet‑Friendly Community",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6c3dfacf-a41d-4df3-a05d-e672446540dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "external_id": "false",
      "title": "Lush Landscaping",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_980fdd16-bae1-4fd7-89b6-83c3422c1a82",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "external_id": "false",
      "title": "Carpeted Bedrooms",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9523a9a2-3465-4f03-819f-743aa5e76085",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a21f7572-03b3-4ff0-9e7b-34c550c25aa9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "external_id": "false",
      "title": "Window Coverings",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9a8fca70-3ab2-4c07-9e34-c21b74c5dcd7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "external_id": "false",
      "title": "LVP Flooring",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d95ce51e-cd18-4a70-98a2-0550a1284588",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless-Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_93523dc6-3d31-4c96-af95-240dfb856139",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "external_id": "false",
      "title": "Washer/Dryer Hookup",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_66e73520-a0b1-41ba-b114-f5b2a10ae065",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "external_id": "false",
      "title": "Refrigerator",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ee6f153d-8a0b-43c4-bbf3-0afa68512fa4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "external_id": "false",
      "title": "Range",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_04a30044-1ff0-4377-bec0-272be3623a7f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "external_id": "false",
      "title": "High Speed Internet Access",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_4be346a4-f32f-405f-b318-c57c0e137c97",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019e02ad-2195-700f-9787-4887f56bb000.webp",
      "image_media": {
        "alt_text": "Aerial view of a multifamily property with apartment buildings, a swimming pool, and a playground at Ashton Pointe apartments in Monroe, GA.",
        "public_id": "019e02ad-2195-700f-9787-4887f56bb000",
        "storage_key": "property/6767906449167330/019e02ad-2195-700f-9787-4887f56bb000.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Discover our community's amenities, including a sparkling swimming pool and a fun playground, perfect for relaxation and recreation. Enjoy the serene setting with lush greenery.",
      "link": "",
      "alt_text": "Aerial view of a multifamily property with apartment buildings, a swimming pool, and a playground at Ashton Pointe apartments in Monroe, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_10a8ebc9-18aa-4847-a03c-57293f602bd3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019e02ad-14ef-72d9-ba1e-fb2c63d4d442.webp",
      "image_media": {
        "alt_text": "Bright blue swimming pool with lounge chairs and white fence surrounding it, with apartment buildings in the background at Ashton Pointe apartments in Monroe, GA.",
        "public_id": "019e02ad-14ef-72d9-ba1e-fb2c63d4d442",
        "storage_key": "property/6767906449167330/019e02ad-14ef-72d9-ba1e-fb2c63d4d442.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, surrounded by lush greenery and comfortable lounge seating. Enjoy a refreshing dip on a warm day.",
      "link": "",
      "alt_text": "Bright blue swimming pool with lounge chairs and white fence surrounding it, with apartment buildings in the background at Ashton Pointe apartments in Monroe, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0230126d-67c7-4dfb-a735-2909ef68a1c3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019e02ac-fc87-716e-83b8-efa99f0237ff.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with balconies and cars parked outside at Ashton Pointe apartments in Monroe, GA.",
        "public_id": "019e02ac-fc87-716e-83b8-efa99f0237ff",
        "storage_key": "property/6767906449167330/019e02ac-fc87-716e-83b8-efa99f0237ff.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "View of the exterior of an apartment building complex, showcasing the architecture and surrounding greenery.",
      "link": "",
      "alt_text": "Apartment building exterior with balconies and cars parked outside at Ashton Pointe apartments in Monroe, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_033764e2-42a6-45e2-a207-046f1fccffeb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019e02ac-ad77-7765-8b20-c1b587fb4444.webp",
      "image_media": {
        "alt_text": "Open concept living and kitchen area with white cabinets and a breakfast bar at Ashton Pointe apartments in Monroe, GA.",
        "public_id": "019e02ac-ad77-7765-8b20-c1b587fb4444",
        "storage_key": "property/6767906449167330/019e02ac-ad77-7765-8b20-c1b587fb4444.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy the open-concept layout of this apartment, featuring a modern kitchen with ample cabinet space and a convenient breakfast bar, perfect for casual dining.",
      "link": "",
      "alt_text": "Open concept living and kitchen area with white cabinets and a breakfast bar at Ashton Pointe apartments in Monroe, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b0d0e4e1-a17a-46a5-a039-bbb52cf4880a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019e02ad-1de8-7625-979e-a4af76223673.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings, swimming pool, and playground at Ashton Pointe apartments in Monroe, GA.",
        "public_id": "019e02ad-1de8-7625-979e-a4af76223673",
        "storage_key": "property/6767906449167330/019e02ad-1de8-7625-979e-a4af76223673.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Discover comfortable living with resort-style amenities including a sparkling swimming pool and a fun playground, all set amidst lush green surroundings.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings, swimming pool, and playground at Ashton Pointe apartments in Monroe, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0c8d3177-6881-427b-9637-665c58f5c7d4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019e02ad-1486-743b-88e6-fb24e2d0753a.webp",
      "image_media": {
        "alt_text": "Ashton Pointe Apartment Homes Monument Signage at Ashton Pointe apartments in Monroe, GA",
        "public_id": "019e02ad-1486-743b-88e6-fb24e2d0753a",
        "storage_key": "property/6767906449167330/019e02ad-1486-743b-88e6-fb24e2d0753a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to Ashton Pointe Apartment Homes, featuring beautiful landscaping and clear signage for easy navigation.",
      "link": "",
      "alt_text": "Ashton Pointe Apartment Homes Monument Signage at Ashton Pointe apartments in Monroe, GA",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1f5a442d-4fee-4656-8d9a-477bec50c57c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019e02ac-ae39-7149-8356-4d2ca9239af8.webp",
      "image_media": {
        "alt_text": "Covered balcony with seating overlooking wooded area at Ashton Pointe apartments in Monroe, GA.",
        "public_id": "019e02ac-ae39-7149-8356-4d2ca9239af8",
        "storage_key": "property/6767906449167330/019e02ac-ae39-7149-8356-4d2ca9239af8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening relaxation on this spacious, covered balcony. Perfect for taking in the serene views of the surrounding nature.",
      "link": "",
      "alt_text": "Covered balcony with seating overlooking wooded area at Ashton Pointe apartments in Monroe, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9306f032-f5f9-40aa-b75c-535faeee018d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019e02ac-c1cd-76be-89fa-b1e3482d7d6f.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with a paved walkway leading to the entrance at Ashton Pointe apartments in Monroe, GA.",
        "public_id": "019e02ac-c1cd-76be-89fa-b1e3482d7d6f",
        "storage_key": "property/6767906449167330/019e02ac-c1cd-76be-89fa-b1e3482d7d6f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Beautifully maintained apartment complex with manicured lawns and well-kept building exteriors.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with a paved walkway leading to the entrance at Ashton Pointe apartments in Monroe, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cb313e1e-2c03-407f-b6f9-564866fb60da",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019e02ad-0111-7448-a091-603b648ca553.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with a parking lot and cars at Ashton Pointe apartments in Monroe, GA.",
        "public_id": "019e02ad-0111-7448-a091-603b648ca553",
        "storage_key": "property/6767906449167330/019e02ad-0111-7448-a091-603b648ca553.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior view of apartment buildings with a parking lot and cars. This image showcases the apartment complex's facade and surrounding environment.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with a parking lot and cars at Ashton Pointe apartments in Monroe, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ddc5e52a-5d9f-4162-bf77-22c94d0435ab",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019e02ad-04ac-70df-8bcc-381421db7e14.webp",
      "image_media": {
        "alt_text": "Sparkling outdoor swimming pool with a large deck area and building in the background at Ashton Pointe apartments in Monroe, GA.",
        "public_id": "019e02ad-04ac-70df-8bcc-381421db7e14",
        "storage_key": "property/6767906449167330/019e02ad-04ac-70df-8bcc-381421db7e14.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our beautiful outdoor swimming pool, perfect for relaxing and unwinding on sunny days. The spacious deck provides ample room for lounging and soaking up the sun.",
      "link": "",
      "alt_text": "Sparkling outdoor swimming pool with a large deck area and building in the background at Ashton Pointe apartments in Monroe, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_995be412-ab9a-454b-b73c-7304ba4060b8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019e02ac-ac66-734d-9a4e-fdbcdab51e18.webp",
      "image_media": {
        "alt_text": "Modern apartment bathroom with white bathtub, toilet, and vanity with sink and mirror at Ashton Pointe apartments in Monroe, GA.",
        "public_id": "019e02ac-ac66-734d-9a4e-fdbcdab51e18",
        "storage_key": "property/6767906449167330/019e02ac-ac66-734d-9a4e-fdbcdab51e18.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and clean apartment bathroom featuring a bathtub/shower combo, a comfortable toilet, and a well-lit vanity area with ample storage.",
      "link": "",
      "alt_text": "Modern apartment bathroom with white bathtub, toilet, and vanity with sink and mirror at Ashton Pointe apartments in Monroe, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_316e8159-9eb5-4dd7-a0e4-5b642b2f018d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019e02ac-e2b2-74c8-9f6c-ce114e803021.webp",
      "image_media": {
        "alt_text": "Playground with swings and slides next to a dense forest at Ashton Pointe apartments in Monroe, GA.",
        "public_id": "019e02ac-e2b2-74c8-9f6c-ce114e803021",
        "storage_key": "property/6767906449167330/019e02ac-e2b2-74c8-9f6c-ce114e803021.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, featuring swings and slides, set against a backdrop of beautiful pine trees.",
      "link": "",
      "alt_text": "Playground with swings and slides next to a dense forest at Ashton Pointe apartments in Monroe, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_13d023a9-d9a8-4dc0-a982-967bf4075af0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019e02ac-cac5-715f-889c-adacc75f286f.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, white countertops, and stainless steel appliances at Ashton Pointe apartments in Monroe, GA.",
        "public_id": "019e02ac-cac5-715f-889c-adacc75f286f",
        "storage_key": "property/6767906449167330/019e02ac-cac5-715f-889c-adacc75f286f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Bright and spacious kitchen featuring ample cabinet and counter space, perfect for meal preparation.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, white countertops, and stainless steel appliances at Ashton Pointe apartments in Monroe, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7d2fe886-ea6f-4acc-ab9c-490bc0954677",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019e02ac-c9ee-732b-9f68-a6d107cf3014.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, dresser, and TV at Ashton Pointe apartments in Monroe, GA.",
        "public_id": "019e02ac-c9ee-732b-9f68-a6d107cf3014",
        "storage_key": "property/6767906449167330/019e02ac-c9ee-732b-9f68-a6d107cf3014.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a comfortable queen-size bed, a spacious dresser with a television, and a ceiling fan for added comfort.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, dresser, and TV at Ashton Pointe apartments in Monroe, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_63efe67e-0289-4258-ae45-c0de6cc90ff0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019e02ac-c8c1-736a-bc6c-c3b43aabcbc4.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with parking spaces and greenery at Ashton Pointe apartments in Monroe, GA.",
        "public_id": "019e02ac-c8c1-736a-bc6c-c3b43aabcbc4",
        "storage_key": "property/6767906449167330/019e02ac-c8c1-736a-bc6c-c3b43aabcbc4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior view of an apartment building, showcasing its facade, balconies, and surrounding landscape. Includes parking and accessible parking.",
      "link": "",
      "alt_text": "Apartment building exterior with parking spaces and greenery at Ashton Pointe apartments in Monroe, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6fcbb01b-cdfd-4171-b77c-d547e25c9360",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019e02ac-c0a5-71cf-959b-928399a4be99.webp",
      "image_media": {
        "alt_text": "The leasing center building entrance with a paved walkway, flowering plants, and lush greenery at Ashton Pointe apartments in Monroe, GA.",
        "public_id": "019e02ac-c0a5-71cf-959b-928399a4be99",
        "storage_key": "property/6767906449167330/019e02ac-c0a5-71cf-959b-928399a4be99.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to our leasing center, where our friendly staff is ready to assist you. Discover your new home in our vibrant community.",
      "link": "",
      "alt_text": "The leasing center building entrance with a paved walkway, flowering plants, and lush greenery at Ashton Pointe apartments in Monroe, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_df0d31c6-07cf-4467-a911-7f25d0b9882d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019e02ac-b1b0-7556-bf7e-ba71ac99377b.webp",
      "image_media": {
        "alt_text": "Dining area and kitchen view in an apartment at Ashton Pointe apartments in Monroe, GA.",
        "public_id": "019e02ac-b1b0-7556-bf7e-ba71ac99377b",
        "storage_key": "property/6767906449167330/019e02ac-b1b0-7556-bf7e-ba71ac99377b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "The dining area features a wooden table with chairs, perfect for meals. Beyond, the kitchen offers ample counter space and white cabinetry.",
      "link": "",
      "alt_text": "Dining area and kitchen view in an apartment at Ashton Pointe apartments in Monroe, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cb7375dc-f10d-433e-8dbb-37ee9874c1c0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019e02ac-c54b-7769-9369-d5ef2e5fa73e.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies, parking lot, and manicured lawns at Ashton Pointe apartments in Monroe, GA.",
        "public_id": "019e02ac-c54b-7769-9369-d5ef2e5fa73e",
        "storage_key": "property/6767906449167330/019e02ac-c54b-7769-9369-d5ef2e5fa73e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Beautifully maintained apartment complex featuring spacious balconies, ample parking, and lush green spaces for residents to enjoy.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with balconies, parking lot, and manicured lawns at Ashton Pointe apartments in Monroe, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_19783842-48fe-4b56-927a-882a7429de5f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "620 GA-138, Monroe, GA 30655, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this fast food restaurant serves fresh, hot food, including chicken sandwiches, nuggets, and waffle fries. They highlight the fast service and friendly staff. They also like the convenient drive-thru and mobile app ordering.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54dd-79d1-7538-be6e-709443e8a40f.webp",
      "poi_featured_image_media": {
        "alt_text": "Indoor dining area with tables, booths, and a children's high chair.",
        "public_id": "019d54dd-79d1-7538-be6e-709443e8a40f",
        "storage_key": "property/6767906449167330/019d54dd-79d1-7538-be6e-709443e8a40f.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ga/monroe-ga?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=8940932553396065646&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "33.7958236",
      "poi_longitude": "-83.7413011",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 770-266-0211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54de-1585-774e-ab92-92464f81b7aa.webp",
      "poi_map_icon_media": {
        "alt_text": "Fork and knife icon",
        "public_id": "019d54de-1585-774e-ab92-92464f81b7aa",
        "storage_key": "property/6767906449167330/019d54de-1585-774e-ab92-92464f81b7aa.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJOVxTwifQ9YgRbhXmRcmSFHw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_0ab79016-821b-4845-bbba-1af2ec08e44b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "poi_name": "Le Gabrielle Crepes & Waffles",
      "poi_type": "Restaurants",
      "poi_address": "125 N Wayne St, Monroe, GA 30655, USA",
      "poi_short_description": "Elegant eatery featuring an assortment of sweet and savory crepes, plus a brunch menu.",
      "poi_long_description": "People say this restaurant serves delicious crepes, waffles, and breakfast items, including shrimp and grits, lobster and shrimp crepes, and eggs Benedict. They highlight the flavorful food, generous portions, and fresh ingredients. They also like the attentive service and welcoming atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54dd-6ce2-703a-94cf-886bd54ba2b4.webp",
      "poi_featured_image_media": {
        "alt_text": "Interior dining area with black leather booths and wood accent wall.",
        "public_id": "019d54dd-6ce2-703a-94cf-886bd54ba2b4",
        "storage_key": "property/6767906449167330/019d54dd-6ce2-703a-94cf-886bd54ba2b4.webp",
        "width": 3072,
        "height": 2313
      },
      "poi_business_url": "https://www.legabrielle.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2204938322237566825&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "le-gabrielle-crepes--waffles",
      "poi_latitude": "33.7953923",
      "poi_longitude": "-83.714343",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 706-395-8996",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54de-1585-774e-ab92-92464f81b7aa.webp",
      "poi_map_icon_media": {
        "alt_text": "Fork and knife icon",
        "public_id": "019d54de-1585-774e-ab92-92464f81b7aa",
        "storage_key": "property/6767906449167330/019d54de-1585-774e-ab92-92464f81b7aa.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJnQA0O_LR9YgRaa-dyLiDmR4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_7664ebae-5a5d-4dda-b9f2-dcf34aeb94a2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "poi_name": "Huey Magoo's Chicken Tenders",
      "poi_type": "Restaurants",
      "poi_address": "601 Pavilion Pkwy, Monroe, GA 30655, USA",
      "poi_short_description": "",
      "poi_long_description": "Diners say this chicken restaurant serves up delicious chicken tenders with a variety of sauces, including the Huey and honey mustard, and tasty fries. They also highlight the friendly and helpful staff, and the clean and welcoming atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54dd-6cf3-7435-9494-b23d64cc7abe.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of Huey Magoo's restaurant with outdoor seating.",
        "public_id": "019d54dd-6cf3-7435-9494-b23d64cc7abe",
        "storage_key": "property/6767906449167330/019d54dd-6cf3-7435-9494-b23d64cc7abe.webp",
        "width": 3072,
        "height": 2313
      },
      "poi_business_url": "https://hueymagoos.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11999474812673625527&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "huey-magoos-chicken-tenders",
      "poi_latitude": "33.8061891",
      "poi_longitude": "-83.7342834",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 470-504-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54de-1585-774e-ab92-92464f81b7aa.webp",
      "poi_map_icon_media": {
        "alt_text": "Fork and knife icon",
        "public_id": "019d54de-1585-774e-ab92-92464f81b7aa",
        "storage_key": "property/6767906449167330/019d54de-1585-774e-ab92-92464f81b7aa.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJxUiMYwDR9YgRt42oJMSyhqY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chicken_restaurant"
    },
    {
      "id": "custom_40ed15dd-09ad-4bad-b72f-7261ae59bd2a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "poi_name": "Tokyo Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "250 M.L.K. Jr Blvd, Monroe, GA 30655, USA",
      "poi_short_description": "Traditional Japanese fare including sushi, steak, chicken and shrimp cooked at hibachi grills in a spacious, casual setting, plus fried rice and bento boxes.",
      "poi_long_description": "People say this Japanese restaurant serves delicious hibachi, sushi, and steak. They also highlight the generous portions, reasonable prices, and clean atmosphere.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54dd-6a6f-77ff-a0bf-42d55ace8f3a.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior view of Tokyo Hibachi & Sushi restaurant entrance with a sign.",
        "public_id": "019d54dd-6a6f-77ff-a0bf-42d55ace8f3a",
        "storage_key": "property/6767906449167330/019d54dd-6a6f-77ff-a0bf-42d55ace8f3a.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://www.tokyomonroega.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=600243428095237353&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tokyo-restaurant",
      "poi_latitude": "33.7922464",
      "poi_longitude": "-83.7459284",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 770-207-1134",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54de-1585-774e-ab92-92464f81b7aa.webp",
      "poi_map_icon_media": {
        "alt_text": "Fork and knife icon",
        "public_id": "019d54de-1585-774e-ab92-92464f81b7aa",
        "storage_key": "property/6767906449167330/019d54de-1585-774e-ab92-92464f81b7aa.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ83zVphbQ9YgR6Rxhtjd-VAg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_f2275648-309a-47b9-8a0a-0d18cbcaf4ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "poi_name": "LongHorn Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "185 M.L.K. Jr Blvd, Monroe, GA 30655, USA",
      "poi_short_description": "Casual steakhouse chain known for grilled beef & other American dishes in a ranch-style space.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, salads, and burgers. They also highlight the attentive service and great atmosphere.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54dd-7a3e-761e-9300-8fd1f7165d9f.webp",
      "poi_featured_image_media": {
        "alt_text": "Longhorn Steakhouse building exterior with cars parked in the lot",
        "public_id": "019d54dd-7a3e-761e-9300-8fd1f7165d9f",
        "storage_key": "property/6767906449167330/019d54dd-7a3e-761e-9300-8fd1f7165d9f.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.longhornsteakhouse.com/locations/ga/monroe/monroe-ga/5329?cmpid=br:lh_ag:ie_ch:loc_ca:LHGMB_sn:gmb_gt:monroe-ga-5329_pl:locurl_rd:1276",
      "poi_directions_map_url": "https://maps.google.com/?cid=7750367235509798366&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "longhorn-steakhouse",
      "poi_latitude": "33.793217",
      "poi_longitude": "-83.743434",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 770-266-5620",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54de-1585-774e-ab92-92464f81b7aa.webp",
      "poi_map_icon_media": {
        "alt_text": "Fork and knife icon",
        "public_id": "019d54de-1585-774e-ab92-92464f81b7aa",
        "storage_key": "property/6767906449167330/019d54de-1585-774e-ab92-92464f81b7aa.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ31abaWvQ9YgR3kVj_-_Vjms",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_50b0d3ef-efb5-4339-976d-c273b2d04468",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "poi_name": "Publix Super Market at Monroe Pavilion",
      "poi_type": "Shopping & Retail",
      "poi_address": "900 Pavilion Pkwy, Monroe, GA 30656, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "People say this supermarket offers fresh produce, good meats, and a wide selection of products, including sandwiches and subs. They highlight the clean and organized store, and the friendly and helpful staff. They also like the convenient location and easy access.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54dd-6c37-7284-ad3f-df58a43e83cf.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of a Publix Food & Pharmacy grocery store.",
        "public_id": "019d54dd-6c37-7284-ad3f-df58a43e83cf",
        "storage_key": "property/6767906449167330/019d54dd-6c37-7284-ad3f-df58a43e83cf.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=1736&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=16893290165041585487&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "publix-super-market-at-monroe-pavilion",
      "poi_latitude": "33.8055585",
      "poi_longitude": "-83.7322197",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 678-635-4316",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54de-1553-75c0-a20d-db63cf702607.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019d54de-1553-75c0-a20d-db63cf702607",
        "storage_key": "property/6767906449167330/019d54de-1553-75c0-a20d-db63cf702607.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo4t2BFLR9YgRT13njuYFceo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_48e0b802-35b9-4e76-a9ee-bdefa548962f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "2150 W Spring St, Monroe, GA 30655, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54dd-69a9-76ca-895c-ee0cb26d595f.webp",
      "poi_featured_image_media": {
        "alt_text": "The Home Depot store exterior",
        "public_id": "019d54dd-69a9-76ca-895c-ee0cb26d595f",
        "storage_key": "property/6767906449167330/019d54dd-69a9-76ca-895c-ee0cb26d595f.webp",
        "width": 704,
        "height": 292
      },
      "poi_business_url": "https://www.homedepot.com/l/Monroe/GA/Monroe/30655/1774?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=608132416200285722&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "33.8008884",
      "poi_longitude": "-83.74510529999999",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 770-266-0550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54de-1553-75c0-a20d-d75c95be087f.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon",
        "public_id": "019d54de-1553-75c0-a20d-d75c95be087f",
        "storage_key": "property/6767906449167330/019d54de-1553-75c0-a20d-d75c95be087f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ83zVphbQ9YgRGp4E5DWFcAg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_fca6ec86-a2bc-44c7-9e1a-db027c662889",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "poi_name": "Ross Dress for Less",
      "poi_type": "Shopping & Retail",
      "poi_address": "812 Pavilion Pkwy, Monroe, GA 30656, USA",
      "poi_short_description": "Retail chain selling brand-name clothing, shoes, accessories & housewares at discount prices.",
      "poi_long_description": "Retail chain selling brand-name clothing, shoes, accessories & housewares at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54dd-7ad4-70df-922f-1cce223086e4.webp",
      "poi_featured_image_media": {
        "alt_text": "Ross Dress for Less exterior facade with a vibrant sunset sky.",
        "public_id": "019d54dd-7ad4-70df-922f-1cce223086e4",
        "storage_key": "property/6767906449167330/019d54dd-7ad4-70df-922f-1cce223086e4.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://www.rossstores.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9369794830412614961&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ross-dress-for-less",
      "poi_latitude": "33.8060182",
      "poi_longitude": "-83.7305392",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 943-234-0364",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54de-1553-75c0-a20d-d75c95be087f.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon",
        "public_id": "019d54de-1553-75c0-a20d-d75c95be087f",
        "storage_key": "property/6767906449167330/019d54de-1553-75c0-a20d-d75c95be087f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJE3-og2bR9YgRMQ0JRcEyCII",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_4b69172d-7c52-458c-a2ce-4251db7dc914",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "poi_name": "John's Supermarket",
      "poi_type": "Shopping & Retail",
      "poi_address": "416 S Broad St, Monroe, GA 30655, USA",
      "poi_short_description": "Clean family-owned grocery chain featuring steaks, beer and baked goods , plus a deli.",
      "poi_long_description": "People say this supermarket offers a wide selection of fresh meat, produce, and locally baked goods. They highlight the great prices, especially on meat, and the small-town atmosphere. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54dd-6a19-707f-a017-ca9c45d62dcb.webp",
      "poi_featured_image_media": {
        "alt_text": "Brick building with \"JOHN'S SUPERMARKET\" sign, two people walking in front.",
        "public_id": "019d54dd-6a19-707f-a017-ca9c45d62dcb",
        "storage_key": "property/6767906449167330/019d54dd-6a19-707f-a017-ca9c45d62dcb.webp",
        "width": 680,
        "height": 453
      },
      "poi_business_url": "https://johnsmonroe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1339491501350996&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "johns-supermarket",
      "poi_latitude": "33.7892827",
      "poi_longitude": "-83.7118796",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 770-267-5632",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54de-1553-75c0-a20d-db63cf702607.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019d54de-1553-75c0-a20d-db63cf702607",
        "storage_key": "property/6767906449167330/019d54de-1553-75c0-a20d-db63cf702607.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqRj5VPLQ9YgRVCAeq0LCBAA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_76047d0f-9147-4654-947c-7dd0dcb33f24",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "poi_name": "The Story Shop",
      "poi_type": "Shopping & Retail",
      "poi_address": "124 N Broad St, Monroe, GA 30655, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this children's bookstore is magical, with fun decorations and details to explore, as well as a great selection of books. They also highlight the friendly, helpful, and engaging staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54dd-8e7f-7627-9c0d-19a0412baa0d.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of The Story Shop, a children's bookstore, with a charming facade and an A-frame sign.",
        "public_id": "019d54dd-8e7f-7627-9c0d-19a0412baa0d",
        "storage_key": "property/6767906449167330/019d54dd-8e7f-7627-9c0d-19a0412baa0d.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "http://www.visitthestoryshop.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10692205917331774913&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-story-shop",
      "poi_latitude": "33.7955833",
      "poi_longitude": "-83.7130856",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 678-635-8801",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54de-1553-75c0-a20d-d75c95be087f.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon",
        "public_id": "019d54de-1553-75c0-a20d-d75c95be087f",
        "storage_key": "property/6767906449167330/019d54de-1553-75c0-a20d-d75c95be087f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJN4Z5X4zQ9YgRwd3jz6FYYpQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "book_store"
    },
    {
      "id": "custom_c93bc5a7-be54-4a54-a8df-b5d2a2d4794e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "poi_name": "George Walton Academy",
      "poi_type": "Education",
      "poi_address": "1 Bulldog Dr, Monroe, GA 30655, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54dd-9536-72c4-86c0-d70abba747c6.webp",
      "poi_featured_image_media": {
        "alt_text": "Brick building with a clock tower and a bell",
        "public_id": "019d54dd-9536-72c4-86c0-d70abba747c6",
        "storage_key": "property/6767906449167330/019d54dd-9536-72c4-86c0-d70abba747c6.webp",
        "width": 1424,
        "height": 700
      },
      "poi_business_url": "http://www.gwa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17307386663454790617&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "george-walton-academy",
      "poi_latitude": "33.7897801",
      "poi_longitude": "-83.74006849999999",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 678-635-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54de-156a-730f-84e5-85c06b7b5e78.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d54de-156a-730f-84e5-85c06b7b5e78",
        "storage_key": "property/6767906449167330/019d54de-156a-730f-84e5-85c06b7b5e78.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcXUPikDQ9YgR2VOO0XgwMPA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_8c4f42f6-bc7f-443b-9352-3ec94ee58a73",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "poi_name": "Athens Technical College - Monroe Campus",
      "poi_type": "Education",
      "poi_address": "212 Bryant Rd, Monroe, GA 30655, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54dd-9641-71ea-af8e-22e8f92686fb.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior view of brick buildings with large trees and green lawn.",
        "public_id": "019d54dd-9641-71ea-af8e-22e8f92686fb",
        "storage_key": "property/6767906449167330/019d54dd-9641-71ea-af8e-22e8f92686fb.webp",
        "width": 1170,
        "height": 820
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5990230688498625540&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "athens-technical-college---monroe-campus",
      "poi_latitude": "33.8028809",
      "poi_longitude": "-83.7062133",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 706-552-0901",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54de-156a-730f-84e5-85c06b7b5e78.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d54de-156a-730f-84e5-85c06b7b5e78",
        "storage_key": "property/6767906449167330/019d54de-156a-730f-84e5-85c06b7b5e78.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ0dja7ZDQ9YgRBKya1hKTIVM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_f4779bf7-fd28-4a41-adf5-983cbbb7eff8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "poi_name": "Monroe-Walton County Library",
      "poi_type": "Education",
      "poi_address": "217 W Spring St, Monroe, GA 30655, USA",
      "poi_short_description": "Part of a 9-member library system, this facility features programs and Wi-Fi, plus kid-friendly activities.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54dd-a00a-724a-aaaa-d485ad266b23.webp",
      "poi_featured_image_media": {
        "alt_text": "Children's library space with books, alphabet rug, and tables.",
        "public_id": "019d54dd-a00a-724a-aaaa-d485ad266b23",
        "storage_key": "property/6767906449167330/019d54dd-a00a-724a-aaaa-d485ad266b23.webp",
        "width": 3072,
        "height": 2101
      },
      "poi_business_url": "https://www.azalealibraries.org/mr-county-library",
      "poi_directions_map_url": "https://maps.google.com/?cid=15463186361171355133&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "monroe-walton-county-library",
      "poi_latitude": "33.79405",
      "poi_longitude": "-83.7155444",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 770-267-4630",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54de-156a-730f-84e5-85c06b7b5e78.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d54de-156a-730f-84e5-85c06b7b5e78",
        "storage_key": "property/6767906449167330/019d54de-156a-730f-84e5-85c06b7b5e78.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJYSXrZovQ9YgR_aVIaRFGmNY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_5af536a6-b5f6-4207-9dde-6cf32a0619b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "poi_name": "McDaniel-Tichenor House",
      "poi_type": "Entertainment",
      "poi_address": "319 McDaniel St, Monroe, GA 30655, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54dd-9ed6-73bc-ba8a-97848ce99560.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of a historic red brick building with white columns and black shutters, surrounded by lush greenery.",
        "public_id": "019d54dd-9ed6-73bc-ba8a-97848ce99560",
        "storage_key": "property/6767906449167330/019d54dd-9ed6-73bc-ba8a-97848ce99560.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.mcdaniel-tichenor.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10348970228384900184&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mcdaniel-tichenor-house",
      "poi_latitude": "33.7907802",
      "poi_longitude": "-83.715887",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 770-267-5602",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54de-1569-7053-9aec-4b2daa5a9a83.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54de-1569-7053-9aec-4b2daa5a9a83",
        "storage_key": "property/6767906449167330/019d54de-1569-7053-9aec-4b2daa5a9a83.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqZatl_TQ9YgRWKT5bZftno8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_fdc93fd3-2c60-4a77-9769-a697eda4069c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "poi_name": "Monroe Museum",
      "poi_type": "Entertainment",
      "poi_address": "227 S Broad St, Monroe, GA 30655, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54dd-9a21-7004-90e0-46cb03962846.webp",
      "poi_featured_image_media": {
        "alt_text": "Front entrance of the City Hall building, with signage for Monroe Museum and Monroe Visitors Center.",
        "public_id": "019d54dd-9a21-7004-90e0-46cb03962846",
        "storage_key": "property/6767906449167330/019d54dd-9a21-7004-90e0-46cb03962846.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "http://monroegamuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3641994151141530450&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "monroe-museum",
      "poi_latitude": "33.79277980000001",
      "poi_longitude": "-83.7124828",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 678-635-8997",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54de-1554-77e0-b4c6-a095079e958d.webp",
      "poi_map_icon_media": {
        "alt_text": "Logo icon",
        "public_id": "019d54de-1554-77e0-b4c6-a095079e958d",
        "storage_key": "property/6767906449167330/019d54de-1554-77e0-b4c6-a095079e958d.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6ra0ozQ9YgRUlvXZGL2ijI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_0d54690f-d10c-4ddb-8d1b-4062af4e370c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "poi_name": "Hurricane Stadium",
      "poi_type": "Entertainment",
      "poi_address": "300 Double Springs Church Rd, Monroe, GA 30656, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54dd-9916-729e-b181-875014c841e4.webp",
      "poi_featured_image_media": {
        "alt_text": "Aerial view of a football stadium with purple and white markings and bleachers.",
        "public_id": "019d54dd-9916-729e-b181-875014c841e4",
        "storage_key": "property/6767906449167330/019d54dd-9916-729e-b181-875014c841e4.webp",
        "width": 1240,
        "height": 827
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12652415307219586032&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hurricane-stadium",
      "poi_latitude": "33.8207468",
      "poi_longitude": "-83.73594729999999",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54de-1557-774b-868d-cbc3346e7bd0.webp",
      "poi_map_icon_media": {
        "alt_text": "Generic icon symbolizing community",
        "public_id": "019d54de-1557-774b-868d-cbc3346e7bd0",
        "storage_key": "property/6767906449167330/019d54de-1557-774b-868d-cbc3346e7bd0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJF2GICMzb9YgR8MuJwa9olq8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_5226d6b3-ff79-4dfb-9c79-03844f6c5ed7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "614 Pavilion Pkwy, Monroe, GA 30655, USA",
      "poi_short_description": "Clean and spacious gym, offering tanning beds and a spa area.",
      "poi_long_description": "People say this gym offers a wide variety of clean and well-maintained equipment, including cardio machines and resistance training options. They highlight the affordable membership, the \"Judgment Free Zone\" atmosphere, and the consistently tidy facilities. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54dd-a14b-711e-a442-7020a294ead0.webp",
      "poi_featured_image_media": {
        "alt_text": "A busy gym with multiple people working out on various machines.",
        "public_id": "019d54dd-a14b-711e-a442-7020a294ead0",
        "storage_key": "property/6767906449167330/019d54dd-a14b-711e-a442-7020a294ead0.webp",
        "width": 1920,
        "height": 1080
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/monroe-ga?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=443228685998644277&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "33.806929",
      "poi_longitude": "-83.72908319999999",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 470-758-4490",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54de-1569-7053-9aec-4b2daa5a9a83.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54de-1569-7053-9aec-4b2daa5a9a83",
        "storage_key": "property/6767906449167330/019d54de-1569-7053-9aec-4b2daa5a9a83.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1aBAOy3R9YgRNVw2PySqJgY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_30e54cfe-b376-4b15-a352-e5f6dae6a867",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "poi_name": "Salon 124 Monroe",
      "poi_type": "Health and Wellness",
      "poi_address": "134 N Broad St, Monroe, GA 30655, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54dd-b2b4-706e-8c83-97822719e866.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of a brick building with the sign \"SALON 124\" above the entrance.",
        "public_id": "019d54dd-b2b4-706e-8c83-97822719e866",
        "storage_key": "property/6767906449167330/019d54dd-b2b4-706e-8c83-97822719e866.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://salon124.com/locations/monroe/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15146349093217869801&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "salon-124-monroe",
      "poi_latitude": "33.7958307",
      "poi_longitude": "-83.71308479999999",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 678-905-9909",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54de-1569-7053-9aec-4b2daa5a9a83.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54de-1569-7053-9aec-4b2daa5a9a83",
        "storage_key": "property/6767906449167330/019d54de-1569-7053-9aec-4b2daa5a9a83.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ194CKB3R9YgR6Z9PYUCkMtI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_bd8c771c-7260-4dc9-8556-b790f89cf388",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "poi_name": "Brown Veterinary Services and Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "2120 W Spring St Suite 1000, Monroe, GA 30655, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54dd-bf55-767e-8228-e1e5985fb2d2.webp",
      "poi_featured_image_media": {
        "alt_text": "Brown Veterinary Services logo and animal graphic with dog, cat, goat, pig, parrot, and chicken.",
        "public_id": "019d54dd-bf55-767e-8228-e1e5985fb2d2",
        "storage_key": "property/6767906449167330/019d54dd-bf55-767e-8228-e1e5985fb2d2.webp",
        "width": 1024,
        "height": 1536
      },
      "poi_business_url": "http://www.brownveterinary.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1824240269449487115&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "brown-veterinary-services-and-urgent-care",
      "poi_latitude": "33.79893120000001",
      "poi_longitude": "-83.7446071",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 678-464-1712",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54de-1569-7053-9aec-4b2daa5a9a83.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54de-1569-7053-9aec-4b2daa5a9a83",
        "storage_key": "property/6767906449167330/019d54de-1569-7053-9aec-4b2daa5a9a83.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJseg3L4qM9ogRC-N_HdwAURk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_750eaa10-0e12-4a62-a79a-91dbb66c68ca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "poi_name": "Walton Athletic 24",
      "poi_type": "Health and Wellness",
      "poi_address": "1205 W Spring St, Monroe, GA 30655, USA",
      "poi_short_description": "Fitness center offering weight training, aerobics classes, swimming, and massage therapy.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54dd-baf1-77dc-86cc-4ebb2add670a.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of a Walton Athletic 24 building with a parking lot in front.",
        "public_id": "019d54dd-baf1-77dc-86cc-4ebb2add670a",
        "storage_key": "property/6767906449167330/019d54dd-baf1-77dc-86cc-4ebb2add670a.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://waltonathletic.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=208760771383019720&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "walton-athletic-24",
      "poi_latitude": "33.7909258",
      "poi_longitude": "-83.7326473",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 770-267-0031",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54de-1569-7053-9aec-4b2daa5a9a83.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54de-1569-7053-9aec-4b2daa5a9a83",
        "storage_key": "property/6767906449167330/019d54de-1569-7053-9aec-4b2daa5a9a83.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN202JELQ9YgRyEhSxdCq5QI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_f0f5f330-ff17-49e6-baa0-1a1bd5a5123f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "poi_name": "Monroe Fit Body Boot Camp",
      "poi_type": "Health and Wellness",
      "poi_address": "134 M.L.K. Jr Blvd, Monroe, GA 30655, USA",
      "poi_short_description": "Affordable fitness venue, with 30-minute workout classes held for all levels.",
      "poi_long_description": "People say this fitness center offers challenging and diverse workouts that change daily. They highlight the welcoming and friendly atmosphere, and the knowledgeable and encouraging coaches. They also like the supportive community and the availability of childcare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54dd-b3e8-7694-a965-8acad8647e45.webp",
      "poi_featured_image_media": {
        "alt_text": "Two women in M&M costumes at a gym event.",
        "public_id": "019d54dd-b3e8-7694-a965-8acad8647e45",
        "storage_key": "property/6767906449167330/019d54dd-b3e8-7694-a965-8acad8647e45.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://fitbodybootcamp.com/666-monroe-ga/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15820878475568295738&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "monroe-fit-body-boot-camp",
      "poi_latitude": "33.7948975",
      "poi_longitude": "-83.74474239999999",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 470-948-8870",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54de-1569-7053-9aec-4b2daa5a9a83.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54de-1569-7053-9aec-4b2daa5a9a83",
        "storage_key": "property/6767906449167330/019d54de-1569-7053-9aec-4b2daa5a9a83.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt0vWSKHR9YgROi_foiYNj9s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_5ce1c15f-23db-4dc8-a2b5-761c127a761f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "poi_name": "Monroe Veterinary Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "823 E Spring St, Monroe, GA 30655, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54dd-b389-7682-92f9-a859fbfdda49.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior building entrance with red doors, red shutters, and landscaping.",
        "public_id": "019d54dd-b389-7682-92f9-a859fbfdda49",
        "storage_key": "property/6767906449167330/019d54dd-b389-7682-92f9-a859fbfdda49.webp",
        "width": 851,
        "height": 315
      },
      "poi_business_url": "http://www.monroevet.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2124988208752377143&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "monroe-veterinary-clinic",
      "poi_latitude": "33.8008507",
      "poi_longitude": "-83.70202019999999",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 770-267-3690",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54de-1569-7053-9aec-4b2daa5a9a83.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54de-1569-7053-9aec-4b2daa5a9a83",
        "storage_key": "property/6767906449167330/019d54de-1569-7053-9aec-4b2daa5a9a83.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa5jguJfQ9YgRNz2UZoR5fR0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_d5e7f542-759f-4c96-b117-3c8d1d73be62",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "poi_name": "Monroe Animal Care Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "210 W Spring St, Monroe, GA 30655, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54dd-c065-710c-8acb-c949125a24fc.webp",
      "poi_featured_image_media": {
        "alt_text": "Interior of a veterinary clinic examination room with cages and medical equipment.",
        "public_id": "019d54dd-c065-710c-8acb-c949125a24fc",
        "storage_key": "property/6767906449167330/019d54dd-c065-710c-8acb-c949125a24fc.webp",
        "width": 1500,
        "height": 1000
      },
      "poi_business_url": "http://www.monroeanimal.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15092087133789937902&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "monroe-animal-care-hospital",
      "poi_latitude": "33.794654",
      "poi_longitude": "-83.71578799999999",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 770-267-3006",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54de-1569-7053-9aec-4b2daa5a9a83.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54de-1569-7053-9aec-4b2daa5a9a83",
        "storage_key": "property/6767906449167330/019d54de-1569-7053-9aec-4b2daa5a9a83.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYSXrZovQ9YgR7uDKcEndcdE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_150ef194-dd37-4a7d-921e-12adbb31d0e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "poi_name": "Freddy’s BarberShop",
      "poi_type": "Health and Wellness",
      "poi_address": "214 M.L.K. Jr Blvd, Monroe, GA 30655, USA",
      "poi_short_description": "Buzz-cut to beard trim shop, with friendly service, that also caters to kids.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54dd-c255-77af-b5ab-765aae516f2c.webp",
      "poi_featured_image_media": {
        "alt_text": "A barber gives a young boy a haircut in a barber shop.",
        "public_id": "019d54dd-c255-77af-b5ab-765aae516f2c",
        "storage_key": "property/6767906449167330/019d54dd-c255-77af-b5ab-765aae516f2c.webp",
        "width": 934,
        "height": 2000
      },
      "poi_business_url": "https://www.facebook.com/TheFreddysBarberShop",
      "poi_directions_map_url": "https://maps.google.com/?cid=17272134680151160682&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "freddys-barbershop",
      "poi_latitude": "33.7934841",
      "poi_longitude": "-83.74538510000001",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 678-635-5065",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54de-1569-7053-9aec-4b2daa5a9a83.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54de-1569-7053-9aec-4b2daa5a9a83",
        "storage_key": "property/6767906449167330/019d54de-1569-7053-9aec-4b2daa5a9a83.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJydwNzh7R9YgRancd2_rysu8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_f6b8da78-bca7-40ed-84fa-503c4439b78a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "poi_name": "Great Clips",
      "poi_type": "Health and Wellness",
      "poi_address": "1038 Pavilion Pkwy, Monroe, GA 30656, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54dd-c022-76d2-87a0-bf71952da686.webp",
      "poi_featured_image_media": {
        "alt_text": "Great Clips online check-in app displayed on two phones.",
        "public_id": "019d54dd-c022-76d2-87a0-bf71952da686",
        "storage_key": "property/6767906449167330/019d54dd-c022-76d2-87a0-bf71952da686.webp",
        "width": 888,
        "height": 500
      },
      "poi_business_url": "https://salons.greatclips.com/us/ga/monroe/1038-pavilion-pkwy",
      "poi_directions_map_url": "https://maps.google.com/?cid=18197965243008423345&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "great-clips",
      "poi_latitude": "33.80549330000001",
      "poi_longitude": "-83.7326901",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 678-635-8983",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54de-1569-7053-9aec-4b2daa5a9a83.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54de-1569-7053-9aec-4b2daa5a9a83",
        "storage_key": "property/6767906449167330/019d54de-1569-7053-9aec-4b2daa5a9a83.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyV-XYADR9YgRsRVsuPgojPw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_ea7e99cd-f03c-4478-a758-e2908fec956e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "poi_name": "Front Window Barbershop",
      "poi_type": "Health and Wellness",
      "poi_address": "121 N Midland Ave, Monroe, GA 30655, USA",
      "poi_short_description": "Barbershop offering hair cuts and beard trims for all ages in a clean space.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54dd-cb73-73f8-a54d-df6aae9aa35e.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior view of a strip mall with storefronts including a barbershop and a roofing company.",
        "public_id": "019d54dd-cb73-73f8-a54d-df6aae9aa35e",
        "storage_key": "property/6767906449167330/019d54dd-cb73-73f8-a54d-df6aae9aa35e.webp",
        "width": 3072,
        "height": 1384
      },
      "poi_business_url": "https://www.instagram.com/frontwindowbarbershop",
      "poi_directions_map_url": "https://maps.google.com/?cid=13255067144810380842&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "front-window-barbershop",
      "poi_latitude": "33.7956759",
      "poi_longitude": "-83.7118981",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 678-635-7494",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54de-1569-7053-9aec-4b2daa5a9a83.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54de-1569-7053-9aec-4b2daa5a9a83",
        "storage_key": "property/6767906449167330/019d54de-1569-7053-9aec-4b2daa5a9a83.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaZPY-3DR9YgRKr5fAFd187c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_d66b15bc-eaa9-4a3a-838d-56e672044632",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "poi_name": "Piedmont Walton",
      "poi_type": "Health and Wellness",
      "poi_address": "2151 W Spring St, Monroe, GA 30655, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54dd-cb07-70e8-8558-b4c03b150c07.webp",
      "poi_featured_image_media": {
        "alt_text": "Piedmont building exterior with sign at dusk.",
        "public_id": "019d54dd-cb07-70e8-8558-b4c03b150c07",
        "storage_key": "property/6767906449167330/019d54dd-cb07-70e8-8558-b4c03b150c07.webp",
        "width": 2119,
        "height": 1191
      },
      "poi_business_url": "https://www.piedmont.org/locations/piedmont-walton?utm_source=directorylisting&utm_medium=seo&utm_campaign=10223&y_source=1_MTI5OTcwMTMtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=6478331243027135963&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "piedmont-walton",
      "poi_latitude": "33.79880929999999",
      "poi_longitude": "-83.75027109999999",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 770-267-8461",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54de-156b-77fb-84d8-81048bf17b53.webp",
      "poi_map_icon_media": {
        "alt_text": "H logo",
        "public_id": "019d54de-156b-77fb-84d8-81048bf17b53",
        "storage_key": "property/6767906449167330/019d54de-156b-77fb-84d8-81048bf17b53.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJaRUeC_fQ9YgR233yHfGn51k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_1405c576-8b6f-4fcc-83dc-4bfe3f1b347a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "poi_name": "Excellent Pediatrics",
      "poi_type": "Health and Wellness",
      "poi_address": "333 Alcovy St # 1, Monroe, GA 30655, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54dd-cd57-7139-832a-359878bbb893.webp",
      "poi_featured_image_media": {
        "alt_text": "A diverse group of medical professionals, including a doctor and nurses, pose for a photo in front of a colorful, cartoon-themed wall.",
        "public_id": "019d54dd-cd57-7139-832a-359878bbb893",
        "storage_key": "property/6767906449167330/019d54dd-cd57-7139-832a-359878bbb893.webp",
        "width": 3072,
        "height": 1895
      },
      "poi_business_url": "http://www.excellentpediatrics.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6831791646246025815&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "excellent-pediatrics",
      "poi_latitude": "33.7830203",
      "poi_longitude": "-83.71643879999999",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 678-807-2230",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54de-156b-77fb-84d8-81048bf17b53.webp",
      "poi_map_icon_media": {
        "alt_text": "H logo",
        "public_id": "019d54de-156b-77fb-84d8-81048bf17b53",
        "storage_key": "property/6767906449167330/019d54de-156b-77fb-84d8-81048bf17b53.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJe3Tl6vbQ9YgRV7r5TU5mz14",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_b6ab3cf5-3202-4eda-a016-40b952bb2a47",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "poi_name": "Bear Creek Golf Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4125 Lakeside Blvd, Monroe, GA 30655, USA",
      "poi_short_description": "Challenging course featuring lakes and sand traps, plus a shop and friendly staff.",
      "poi_long_description": "People say this golf course offers challenging greens and forgiving fairways, and is a decent value for the price.\n\nOther reviews mention the course can be poorly maintained and the layout can be confusing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54dd-d259-73b2-90fe-8cd650efa2af.webp",
      "poi_featured_image_media": {
        "alt_text": "A golf course with green grass, trees, and a blue sky.",
        "public_id": "019d54dd-d259-73b2-90fe-8cd650efa2af",
        "storage_key": "property/6767906449167330/019d54dd-d259-73b2-90fe-8cd650efa2af.webp",
        "width": 3072,
        "height": 1729
      },
      "poi_business_url": "http://www.bearcreekmonroe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9852545151760977331&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bear-creek-golf-club",
      "poi_latitude": "33.7822447",
      "poi_longitude": "-83.7889867",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 770-207-5511",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54de-1586-713b-b730-cccbdf2a59e1.webp",
      "poi_map_icon_media": {
        "alt_text": "Man playing golf icon",
        "public_id": "019d54de-1586-713b-b730-cccbdf2a59e1",
        "storage_key": "property/6767906449167330/019d54de-1586-713b-b730-cccbdf2a59e1.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJ71alLrHP9YgRs801UJ1Fu4g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_c197a099-4a0c-48c2-863f-607c32699ae0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "poi_name": "Criswell Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Q72R+6P, 1190 Criswell Rd SE, Monroe, GA 30655, USA",
      "poi_short_description": "Playground with slides and swings, plus a baseball field, as well as a disc golf course.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54dd-d2cd-77cf-a5ca-8cc27bd91e92.webp",
      "poi_featured_image_media": {
        "alt_text": "Youth baseball team lined up on the field.",
        "public_id": "019d54dd-d2cd-77cf-a5ca-8cc27bd91e92",
        "storage_key": "property/6767906449167330/019d54dd-d2cd-77cf-a5ca-8cc27bd91e92.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://www.waltoncountyga.gov/facilities/facility/details/Criswell-Park-4",
      "poi_directions_map_url": "https://maps.google.com/?cid=3474796371522905082&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "criswell-park",
      "poi_latitude": "33.7492286",
      "poi_longitude": "-83.70888289999999",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 770-267-7525",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54de-1569-7053-9aec-46a2cfeddd5b.webp",
      "poi_map_icon_media": {
        "alt_text": "Black icon of a Christmas tree.",
        "public_id": "019d54de-1569-7053-9aec-46a2cfeddd5b",
        "storage_key": "property/6767906449167330/019d54de-1569-7053-9aec-46a2cfeddd5b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJb4dP3hLR9YgR-mNwv-P0ODA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c77272e2-b7bd-4e50-a90f-15de511e4498",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "poi_name": "Felker Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "725 S Madison Ave, Monroe, GA 30655, USA",
      "poi_short_description": "Park featuring fields for football and other sports, plus a playground, trail, and bathrooms.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54dd-dc28-77ac-920a-cf6240a80cb3.webp",
      "poi_featured_image_media": {
        "alt_text": "A large, modern playground with green structures and slides.",
        "public_id": "019d54dd-dc28-77ac-920a-cf6240a80cb3",
        "storage_key": "property/6767906449167330/019d54dd-dc28-77ac-920a-cf6240a80cb3.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://waltoncountyga.gov/186/Felker-Park-Community-Center",
      "poi_directions_map_url": "https://maps.google.com/?cid=12775171674531412532&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "felker-park",
      "poi_latitude": "33.785543",
      "poi_longitude": "-83.703751",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 770-267-7525",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54de-1569-7053-9aec-46a2cfeddd5b.webp",
      "poi_map_icon_media": {
        "alt_text": "Black icon of a Christmas tree.",
        "public_id": "019d54de-1569-7053-9aec-46a2cfeddd5b",
        "storage_key": "property/6767906449167330/019d54de-1569-7053-9aec-46a2cfeddd5b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJTwOxS-nQ9YgRNLoTxfOGSrE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_047699aa-9e17-4195-ad95-0524ca86f436",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "poi_name": "Mathews Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1016 E Marable St, Monroe, GA 30655, USA",
      "poi_short_description": "Kid-friendly park with a playground, picnic tables, and a public restroom.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54dd-dce1-72ca-8439-72cc16637782.webp",
      "poi_featured_image_media": {
        "alt_text": "Serene lake with a bench and geese on the grassy shore, surrounded by trees.",
        "public_id": "019d54dd-dce1-72ca-8439-72cc16637782",
        "storage_key": "property/6767906449167330/019d54dd-dce1-72ca-8439-72cc16637782.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1120728064235908160&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mathews-park",
      "poi_latitude": "33.8184048",
      "poi_longitude": "-83.7037987",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 770-267-7525",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54de-1569-7053-9aec-46a2cfeddd5b.webp",
      "poi_map_icon_media": {
        "alt_text": "Black icon of a Christmas tree.",
        "public_id": "019d54de-1569-7053-9aec-46a2cfeddd5b",
        "storage_key": "property/6767906449167330/019d54de-1569-7053-9aec-46a2cfeddd5b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJWW4oIXTa9YgRQKyXjjygjQ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_fa46b530-2ade-4cd1-8d2c-dd8d1d4007b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "poi_name": "Ayers Park - Walton County Splash Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1011 Heritage Pkwy, Between, GA 30655, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54dd-f32f-753f-8b95-4cf3c95b5e0c.webp",
      "poi_featured_image_media": {
        "alt_text": "Children play in a splash pad with water features and a shaded seating area.",
        "public_id": "019d54dd-f32f-753f-8b95-4cf3c95b5e0c",
        "storage_key": "property/6767906449167330/019d54dd-f32f-753f-8b95-4cf3c95b5e0c.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://www.waltoncountyga.gov/581/Between-Splash-Water-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=18092299034337261939&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ayers-park---walton-county-splash-park",
      "poi_latitude": "33.8222177",
      "poi_longitude": "-83.8102971",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54de-1569-7053-9aec-46a2cfeddd5b.webp",
      "poi_map_icon_media": {
        "alt_text": "Black icon of a Christmas tree.",
        "public_id": "019d54de-1569-7053-9aec-46a2cfeddd5b",
        "storage_key": "property/6767906449167330/019d54de-1569-7053-9aec-46a2cfeddd5b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJSepCMinF9YgRc7nQVx3CFPs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b4f901f5-36b9-430c-bbc4-0669298555a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "poi_name": "Monroe-Walton County Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "525 Towler St, Monroe, GA 30655, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54dd-f21a-77a7-b51c-3bf90477b48f.webp",
      "poi_featured_image_media": {
        "alt_text": "Two women pose in front of a small airplane with \"FLIGHT TRAIN MONROE.COM\" visible on the hangar behind them.",
        "public_id": "019d54dd-f21a-77a7-b51c-3bf90477b48f",
        "storage_key": "property/6767906449167330/019d54dd-f21a-77a7-b51c-3bf90477b48f.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.monroega.com/airport",
      "poi_directions_map_url": "https://maps.google.com/?cid=15173581300786590281&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "monroe-walton-county-airport",
      "poi_latitude": "33.7779182",
      "poi_longitude": "-83.694124",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54de-1ad1-74b8-9f96-1708d06e3928.webp",
      "poi_map_icon_media": {
        "alt_text": "Airplane icon",
        "public_id": "019d54de-1ad1-74b8-9f96-1708d06e3928",
        "storage_key": "property/6767906449167330/019d54de-1ad1-74b8-9f96-1708d06e3928.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJNdpknMTQ9YgRSfLky8xjk9I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_283a855c-67e1-4dc1-8d54-701fd45bb4c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "poi_name": "Grow Monroe Bait and Tackle",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1124 S Broad St, Monroe, GA 30655, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54dd-e212-759c-9aab-d61fadb68ace.webp",
      "poi_featured_image_media": {
        "alt_text": "Vintage farming tools and advertising signs displayed on a wooden wall.",
        "public_id": "019d54dd-e212-759c-9aab-d61fadb68ace",
        "storage_key": "property/6767906449167330/019d54dd-e212-759c-9aab-d61fadb68ace.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3022376063067343544&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "grow-monroe-bait-and-tackle",
      "poi_latitude": "33.7802921",
      "poi_longitude": "-83.707658",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 404-808-9202",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54de-1569-7053-9aec-4b2daa5a9a83.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54de-1569-7053-9aec-4b2daa5a9a83",
        "storage_key": "property/6767906449167330/019d54de-1569-7053-9aec-4b2daa5a9a83.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_6ClftnR9YgRuMrFIASj8Sk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_cb7f6fbb-106b-4bcd-8ebb-38c31f4f0261",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "poi_name": "Brookstone Construction Group",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1645 GA-138, Monroe, GA 30655, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54dd-e280-753c-8a87-b68c43cdb683.webp",
      "poi_featured_image_media": {
        "alt_text": "Kitchen island with marble countertop and white cabinets, open to a living room with fireplace and family photos.",
        "public_id": "019d54dd-e280-753c-8a87-b68c43cdb683",
        "storage_key": "property/6767906449167330/019d54dd-e280-753c-8a87-b68c43cdb683.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "http://brookstonecg.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8270927553963672691&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "brookstone-construction-group",
      "poi_latitude": "33.7820815",
      "poi_longitude": "-83.7706596",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 678-251-8029",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54de-1569-7053-9aec-4b2daa5a9a83.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54de-1569-7053-9aec-4b2daa5a9a83",
        "storage_key": "property/6767906449167330/019d54de-1569-7053-9aec-4b2daa5a9a83.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQAQVNDP9YgRc8T-AMo8yHI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_4ed31b79-4b89-4847-a2bf-bda95fbe6875",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "poi_name": "Creekside by Starlight Homes",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1957 GA-83, Monroe, GA 30655, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54de-07eb-7726-b36c-f932b339f343.webp",
      "poi_featured_image_media": {
        "alt_text": "Construction site with heavy machinery, dumpsters, and cement trucks under a blue sky.",
        "public_id": "019d54de-07eb-7726-b36c-f932b339f343",
        "storage_key": "property/6767906449167330/019d54de-07eb-7726-b36c-f932b339f343.webp",
        "width": 1920,
        "height": 1080
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12317988797537717069&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "creekside-by-starlight-homes",
      "poi_latitude": "33.7960242",
      "poi_longitude": "-83.646847",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54de-1569-7053-9aec-4b2daa5a9a83.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54de-1569-7053-9aec-4b2daa5a9a83",
        "storage_key": "property/6767906449167330/019d54de-1569-7053-9aec-4b2daa5a9a83.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ17k9gU7X9YgRTQt6QIxJ8qo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_8733cc8e-d5b9-4a69-8fc0-ebef0f623d2b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "poi_name": "Transitional Care Physicians of Georgia P.C.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "704 Breedlove Dr, Monroe, GA 30655, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.tcpamd.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11967481435371372345&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "transitional-care-physicians-of-georgia-pc",
      "poi_latitude": "33.78262369999999",
      "poi_longitude": "-83.7206842",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 888-772-0076",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/019d54de-1569-7053-9aec-4b2daa5a9a83.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54de-1569-7053-9aec-4b2daa5a9a83",
        "storage_key": "property/6767906449167330/019d54de-1569-7053-9aec-4b2daa5a9a83.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhSv_ggYE9YgROX9kg_UIFaY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_9c959bc8e54376148cdfa59e",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_2072e67ee0c864816b26840e",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_2cc6d7a84be24a8fbcfd4388",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_9bcce18202c99e51e5c5c9ba",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_5fa203753930ab373c30de0b",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_829e4fe2-f755-45e2-ad5c-f8cdf88507d3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "rating": "5",
      "name": "Alysha Astin",
      "text": "Great experience!\n",
      "date": "2026-01-14",
      "title": "false"
    },
    {
      "id": "custom_5f2b1356-ba4f-4005-aa20-9fe22ecb826b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "rating": "5",
      "name": "Ladarrion Heard",
      "text": "Definitely felt welcoming!!! Nice people, nice apartment complex, pool was very well maintained.",
      "date": "2026-07-24",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_e56aee1a6cdb42878fd0e510",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/01a0513b-0ff0-769d-859e-42415d45f49a.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0513b-0ff0-769d-859e-42415d45f49a",
        "storage_key": "property/6767906449167330/01a0513b-0ff0-769d-859e-42415d45f49a.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Clubhouse",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=yehyKaZHkKw"
    },
    {
      "id": "ec_771c6e3e03b2d2a4001d8981",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167330/01a0513b-0fc2-730c-97e3-67e85f3d7a76.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0513b-0fc2-730c-97e3-67e85f3d7a76",
        "storage_key": "property/6767906449167330/01a0513b-0fc2-730c-97e3-67e85f3d7a76.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Pool",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=5xDQeGdtNca"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019db23f-c368-70ea-8ce1-0ffc6654a8dd",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Ashton Pointe Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330"
    },
    {
      "lead_collector_id": "019db23f-c44f-75e8-a2ba-9964e597f224",
      "lead_source": "FACEBOOK_ADS",
      "name": "Ashton Pointe Facebook Ads",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330"
    },
    {
      "lead_collector_id": "019db23f-c4c4-7486-892c-64472a424885",
      "lead_source": "LANDING_PAGE",
      "name": "Ashton Pointe Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-monroe-ga",
      "search_query": "pet friendly apartments Monroe GA",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in Monroe, GA",
      "h2_subtitle": "Discover pet friendly apartments with spacious living in Monroe, GA. Ashton Pointe welcomes you and your pets to a comfortable, vibrant community.",
      "page_copy": "Welcome to Ashton Pointe, your new home offering pet-friendly apartments in Monroe, GA. Here, your furry friends will enjoy the outdoor space surrounded by lush landscaping while you relax at our sparkling swimming pool. Our community is designed to cater to both you and your pets' comfort, ensuring everyone feels right at home.\n\nLocated conveniently on Plaza Dr., Ashton Pointe not only provides a range of all-white appliances but also ensures easy access to local pet amenities. Our commitment to providing a welcoming atmosphere makes Ashton Pointe the ideal choice for pet lovers looking for a balanced lifestyle in Monroe, GA. Join our community today!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in Monroe, GA",
      "seo_description": "Explore Ashton Pointe's pet-friendly apartments in Monroe, GA. Welcoming atmosphere with lush landscaping and convenient amenities for you and your pets.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "page_item_url": "apartments-with-dishwasher-walton-county",
      "search_query": "apartments with dishwasher Walton County",
      "category": "Amenity",
      "h1_title": "Apartments with Dishwasher in Walton County",
      "h2_subtitle": "Find modern apartments with dishwasher in Walton County. Ashton Pointe provides quality living in a convenient Monroe location with full amenities.",
      "page_copy": "Ashton Pointe Apartments offers modern living with all the conveniences you need in Walton County. Our apartments come equipped with dishwashers, allowing you to enjoy a seamless and efficient lifestyle. Each unit is thoughtfully designed with all-white appliances, ensuring both style and functionality in your kitchen.\n\nNestled in the heart of Monroe, GA, Ashton Pointe is more than just a home; it's a community. Our lush landscaping and sparkling swimming pool are perfect for relaxation. With our strategic location, you’ll have easy access to all Monroe and Walton County has to offer, making your daily routine as smooth as possible. Experience the blend of convenience and comfort at Ashton Pointe.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Dishwasher in Walton County",
      "seo_description": "Discover Ashton Pointe's modern apartments with dishwasher in Walton County. Convenient Monroe location and full amenities for comfortable living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "page_item_url": "apartment-with-pool-monroe-30655",
      "search_query": "apartment with a pool in Monroe 30655",
      "category": "Amenity",
      "h1_title": "Apartment with a Pool in Monroe 30655",
      "h2_subtitle": "Enjoy an apartment with a pool in Monroe's 30655 area. Ashton Pointe offers a retreat with a sparkling swimming pool and lush surroundings.",
      "page_copy": "At Ashton Pointe, enjoy living in an apartment with a pool right in Monroe's 30655 district. Our sparkling swimming pool is the centerpiece of our community, offering a refreshing sanctuary from the everyday hustle. Whether you're lounging poolside or swimming laps, it's the perfect place to unwind and soak up the sun.\n\nLocated conveniently on Plaza Dr., Ashton Pointe creates a serene living environment with lush landscaping that complements our pool area. Inside, you'll find modern amenities including a range of all-white appliances. Choose Ashton Pointe for a blend of relaxation and contemporary living in the heart of Monroe, offering easy access to all that Walton County has to offer.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment with a Pool in Monroe 30655",
      "seo_description": "Find an apartment with a pool in Monroe, 30655. Ashton Pointe provides a sparkling pool and lush surroundings for refreshing living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "page_item_url": "conveniently-located-apartments-monroe-ga",
      "search_query": "conveniently located apartments in Monroe GA",
      "category": "Amenity",
      "h1_title": "Conveniently Located Apartments in Monroe, GA",
      "h2_subtitle": "Discover the best conveniently located apartments in Monroe, GA. Ashton Pointe offers easy access to local amenities and lush surroundings.",
      "page_copy": "Ashton Pointe presents conveniently located apartments in Monroe, GA, perfect for those seeking accessibility and comfort. Situated on Plaza Dr., our community puts you right in the heart of Monroe, making it easy to reach shopping, dining, and entertainment options within minutes.\n\nOur apartments not only boast a prime location but also feature amenities designed for a modern lifestyle. With lush landscaping and a sparkling swimming pool, the tranquil environment provides a welcome escape. Experience the blend of ease and quality living at Ashton Pointe, where convenience meets style, and explore all the charms Walton County has to offer.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Conveniently Located Apartments in Monroe, GA",
      "seo_description": "Explore Ashton Pointe's conveniently located apartments in Monroe, GA, offering easy access to amenities and serene surroundings.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "page_item_url": "apartments-washer-dryer-hookup-monroe",
      "search_query": "apartments with washer dryer hookup Monroe",
      "category": "Amenity",
      "h1_title": "Apartments with Washer Dryer Hookup in Monroe",
      "h2_subtitle": "Find apartments with washer dryer hookup in Monroe. Ashton Pointe offers modern amenities and a comfortable living environment in a prime location.",
      "page_copy": "Ashton Pointe Apartments in Monroe offers the convenience of washer dryer hookups, making laundry day simple and hassle-free. Our community prides itself on providing modern amenities that cater to a contemporary lifestyle. You’ll find that these hookups are just one of many features that make living here exceptionally convenient.\n\nLocated in a vibrant part of Monroe, Ashton Pointe ensures residents enjoy both convenience and comfort. With a sparkling swimming pool and lush landscaping, the community is a relaxing retreat. Nestled in Walton County, our convenient location offers easy access to all local amenities, from shopping to dining. Embrace the ease and quality of life at Ashton Pointe Apartments.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Washer Dryer Hookup in Monroe",
      "seo_description": "Discover Ashton Pointe's apartments with washer dryer hookup in Monroe, offering modern amenities and a central location for convenient living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "page_item_url": "1-bedroom-apartments-monroe-ga",
      "search_query": "1 bedroom apartments in Monroe GA",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Monroe, GA",
      "h2_subtitle": "Explore spacious 1 bedroom apartments in Monroe, GA at Ashton Pointe. Enjoy cozy living with all the amenities you need.",
      "page_copy": "Discover the charm of 1 bedroom apartments at Ashton Pointe, situated in the heart of Monroe, GA. Our community features thoughtfully designed living spaces perfect for those seeking comfort and convenience. Each unit is equipped with modern amenities like a range of all-white appliances, ensuring a stylish and functional living situation.\n\nAshton Pointe provides more than just a home; it's a lifestyle. Residents can enjoy our sparkling swimming pool and relax in beautifully landscaped surroundings. Positioned conveniently in Walton County, our location offers quick access to shops, dining, and entertainment, making your everyday life easy and enjoyable. Choose Ashton Pointe for the ideal blend of comfort and convenience in Monroe.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Monroe, GA",
      "seo_description": "Find cozy 1 bedroom apartments in Monroe, GA at Ashton Pointe, with modern amenities and a prime location for easy, comfortable living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "page_item_url": "2-bedroom-floorplans-walton-county",
      "search_query": "2 bedroom floorplans Walton County",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Floorplans in Walton County",
      "h2_subtitle": "Discover spacious 2 bedroom floorplans in Walton County at Ashton Pointe, where comfort meets convenience in a beautiful setting.",
      "page_copy": "At Ashton Pointe, explore our spacious 2 bedroom floorplans that cater to both style and functionality. Nestled in Walton County, our community provides an ideal living environment complemented by lush landscapes and modern conveniences. These floorplans offer ample space, making them perfect for those looking for a comfortable place to call home.\n\nOur residents enjoy a variety of perks, from a sparkling swimming pool to a prime location in Monroe, GA, providing easy access to local shopping and dining. Embrace a lifestyle that balances tranquility and accessibility, with updated amenities and a welcoming community at Ashton Pointe. Experience the best of Walton County with our thoughtfully designed 2 bedroom options.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Floorplans in Walton County",
      "seo_description": "Explore Ashton Pointe's 2 bedroom floorplans in Walton County, offering spacious living in a community rich with amenities and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "page_item_url": "3-bedroom-apartment-layouts-30655",
      "search_query": "3 bedroom apartment layouts near 30655",
      "category": "Floorplan",
      "h1_title": "3 Bedroom Apartment Layouts Near 30655",
      "h2_subtitle": "Explore diverse 3 bedroom apartment layouts near 30655 at Ashton Pointe, offering ample space and modern amenities.",
      "page_copy": "Ashton Pointe presents a variety of 3 bedroom apartment layouts thoughtfully designed to cater to those seeking spacious living. Situated near the 30655 area, our community provides a blend of comfort, convenience, and contemporary style. These layouts are perfect for those who value extra room without sacrificing modern comforts.\n\nIn addition to roomy interiors, Ashton Pointe offers amenities such as a sparkling swimming pool and lush landscaping, enhancing the overall living experience. Located in the vibrant area of Monroe, GA, you'll appreciate the proximity to essential shops and dining while enjoying the peaceful ambiance of Walton County. Discover the ideal blend of space and lifestyle at Ashton Pointe, where community living comes alive.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Apartment Layouts Near 30655",
      "seo_description": "Find 3 bedroom apartment layouts near 30655 at Ashton Pointe, providing spacious, modern living with convenient access to local amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "page_item_url": "apartments-near-george-walton-academy-monroe-ga",
      "search_query": "apartments near George Walton Academy Monroe GA",
      "category": "School",
      "h1_title": "Apartments Near George Walton Academy",
      "h2_subtitle": "Find ideal apartments near George Walton Academy in Monroe, GA at Ashton Pointe, offering great amenities and a prime location.",
      "page_copy": "Located conveniently near George Walton Academy, Ashton Pointe offers an ideal apartment living experience in Monroe, GA. Our community is perfect for those seeking a nearby home with access to one of the area's premier educational institutions. Enjoy a selection of floor plans suited for various needs along with modern amenities to enhance your living.\n\nAshton Pointe is more than just a place to stay; it's a home where comfort meets convenience. Residents benefit from well-maintained facilities including a sparkling swimming pool and lush green spaces, providing a serene environment. At Ashton Pointe, you are minutes away from local attractions and daily conveniences, ensuring a balanced and vibrant lifestyle in Walton County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near George Walton Academy",
      "seo_description": "Discover Ashton Pointe, offering comfortable apartments near George Walton Academy in Monroe, GA, with excellent amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "page_item_url": "apartments-close-to-athens-technical-college-walton",
      "search_query": "apartments close to Athens Technical College Walton County",
      "category": "School",
      "h1_title": "Apartments Near Athens Technical College",
      "h2_subtitle": "Discover convenient apartments close to Athens Technical College in Walton County at Ashton Pointe.",
      "page_copy": "Ashton Pointe offers the perfect living solution for those seeking apartments close to Athens Technical College in Walton County. Situated in Monroe, GA, our community provides a prime location coupled with modern conveniences aimed at enhancing your academic and professional lifestyle. \n\nWith easy access to the college, residents can enjoy the benefits of a short commute while living in a welcoming environment enriched with amenities like a sparkling swimming pool and lush landscaping. Whether you're a student attending classes or a professional working at the college, Ashton Pointe offers comfort, accessibility, and a sense of community. Experience the best of Walton County living at Ashton Pointe and enjoy a balanced lifestyle just moments from Athens Technical College.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Athens Technical College",
      "seo_description": "Explore Ashton Pointe, offering ideal apartments near Athens Technical College in Walton County, perfect for those seeking comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "page_item_url": "apartments-near-piedmont-walton-monroe-ga",
      "search_query": "apartments near piedmont walton monroe ga",
      "category": "Hospital",
      "h1_title": "Apartments Near Piedmont Walton in Monroe",
      "h2_subtitle": "Find convenient apartments near Piedmont Walton in Monroe, GA. Ashton Pointe offers modern living with excellent amenities close to healthcare.",
      "page_copy": "Ashton Pointe is the go-to choice for those seeking apartments near Piedmont Walton in Monroe, GA. Designed with both comfort and convenience in mind, our community is perfectly situated for anyone who values proximity to excellent medical facilities. Enjoy peace of mind knowing that quality healthcare is just around the corner.\n\nResidents of Ashton Pointe can take advantage of a range of amenities, including a sparkling swimming pool and beautifully maintained landscaping. Our location in the heart of Monroe provides easy access to local dining, shopping, and vibrant community activities, enhancing your living experience. Choose Ashton Pointe for a balanced lifestyle in a supportive and engaging community.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Piedmont Walton in Monroe",
      "seo_description": "Discover Ashton Pointe's convenient apartments near Piedmont Walton in Monroe, GA, offering modern living with great access to healthcare and local amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "page_item_url": "apartments-near-criswell-park-monroe-ga",
      "search_query": "apartments near Criswell Park Monroe GA",
      "category": "Park",
      "h1_title": "Apartments Near Criswell Park, Monroe",
      "h2_subtitle": "Explore apartments near Criswell Park in Monroe, GA at Ashton Pointe. Enjoy easy park access and modern living in a friendly community.",
      "page_copy": "At Ashton Pointe, discover a charming community of apartments near Criswell Park in Monroe, GA. Perfectly nestled close to one of the area’s beloved recreational spots, Ashton Pointe offers residents easy access to outdoor activities and the tranquility of green spaces. Whether you're into leisurely strolls or active sports, the park is just a short distance away.\n\nOur community emphasizes comfortable living with fantastic amenities, including a refreshing swimming pool and scenic landscaping. Situated in Walton County, Ashton Pointe provides not only beautiful living spaces but also a vibrant location with convenient access to local shops, dining, and activities. Live the lifestyle you’ve always wanted in Monroe while enjoying the benefits of an engaging neighborhood at Ashton Pointe.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Criswell Park Monroe, GA",
      "seo_description": "Discover Ashton Pointe, offering beautiful apartments near Criswell Park in Monroe, GA. Enjoy easy access to parks and local amenities in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "page_item_url": "felker-park-nearby-apartments-walton-county",
      "search_query": "Felker Park nearby apartments Walton County",
      "category": "Park",
      "h1_title": "Nearby Apartments to Felker Park",
      "h2_subtitle": "Explore nearby apartments to Felker Park in Walton County at Ashton Pointe. Enjoy convenient living with great local amenities.",
      "page_copy": "Situated within easy reach of Felker Park in Walton County, Ashton Pointe offers a welcoming community atmosphere and modern conveniences for residents seeking nearby apartments. The proximity to Felker Park allows outdoor enthusiasts to readily enjoy recreational activities and open green spaces, enhancing both leisure and lifestyle.\n\nAshton Pointe is located in the vibrant town of Monroe, GA, offering a range of amenities such as a sparkling swimming pool and meticulously landscaped grounds. Our convenient location ensures residents are never far from Walton County's many attractions, including dining, shopping, and community events. Choose Ashton Pointe for an ideal blend of comfort, convenience, and community.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Nearby Apartments to Felker Park Walton County",
      "seo_description": "Discover apartments near Felker Park in Walton County at Ashton Pointe. Enjoy convenient access to parks and local amenities in Monroe, GA.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "page_item_url": "living-close-to-mathews-park-monroe",
      "search_query": "living close to Mathews Park Monroe",
      "category": "Park",
      "h1_title": "Living Close to Mathews Park",
      "h2_subtitle": "Experience the joy of living close to Mathews Park in Monroe. Ashton Pointe offers an ideal location for nature lovers and those seeking convenience.",
      "page_copy": "Ashton Pointe provides the perfect solution for those seeking the benefits of living close to Mathews Park in Monroe. Immerse yourself in the natural beauty and recreational opportunities the park offers while enjoying all the comforts of modern apartment living. Our community is specifically designed to cater to residents who value both convenience and tranquility.\n\nIn addition to its great location, Ashton Pointe boasts ample amenities, including a refreshing swimming pool and lush landscaping that make coming home a pleasure. Our prime spot in Monroe, GA ensures you're well-connected to local dining, shopping, and entertainment, making day-to-day living seamless and enjoyable. Experience a balanced lifestyle at Ashton Pointe, where nature and city life come together.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Close to Mathews Park in Monroe",
      "seo_description": "Discover Ashton Pointe, where living close to Mathews Park in Monroe means enjoying nature alongside modern amenities and conveniences.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167330",
      "source": "custom",
      "page_item_url": "ayers-park-splash-park-apartments-30655",
      "search_query": "Ayers Park Splash Park apartments 30655",
      "category": "Park",
      "h1_title": "Ayers Park Splash Park Apartments",
      "h2_subtitle": "Find apartments near Ayers Park Splash Park in the 30655 area. Ashton Pointe offers a great location and exceptional amenities.",
      "page_copy": "Located in the heart of Monroe, Ashton Pointe is your gateway to exciting outdoor adventures at Ayers Park Splash Park. Apartments in the 30655 zip code offer the perfect blend of convenience and recreation. Just a short distance from the exhilarating water features, residents can enjoy the dynamic lifestyle that the splash park provides.\n\nAshton Pointe complements this ideal location with a range of top-notch amenities, from a sparkling swimming pool to beautifully maintained landscaping. Situated in Walton County, our community places a premium on comfort and accessibility, ensuring you're never far from the best shopping, dining, and entertainment options. Embrace a vibrant new lifestyle at Ashton Pointe today.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Ayers Park Splash Park Apartments 30655",
      "seo_description": "Explore Ashton Pointe, offering ideal Ayers Park Splash Park apartments in Monroe's 30655. Enjoy local parks and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "6073"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11671071879"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-ML7DJF6C"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "2214984cfaf11f0c"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "b484f0cc984e11eebcb40e136090bd39"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "a13533e4-d0cb-11f0-a5ac-333ac8b0a02d"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "ca6e7a0c-0871-4502-b699-60d5f5cfcb57"
    },
    {
      "ID": "custom_eliseai_tour_scheduler_url",
      "type": "STRING",
      "value": "https://app.meetelise.com/ca6e7a0c-0871-4502-b699-60d5f5cfcb57/a13533e4-d0cb-11f0-a5ac-333ac8b0a02d/tour"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6InIwZGZEcTVsL1hyTUtWaTNENHhyQmc9PSIsInZhbHVlIjoibHhnMzlvMFhLUWF5cHZXbnJnNmgxUT09IiwibWFjIjoiYjdhZjliNzgyYWEzYWJiODg5MDlkYzBkOGQwMjA4ZWM2NmQyMzE4MjZjMjE5ZDc3ZTExMjhjYmM5MjhiZmFmOSJ9"
    }
  ],
  "custom_qb_id": "6073",
  "custom_repli_id": "11671071879",
  "custom_google_gtm_id": "GTM-ML7DJF6C",
  "custom_knock_community_id": "2214984cfaf11f0c",
  "custom_knock_company_token": "b484f0cc984e11eebcb40e136090bd39",
  "custom_eliseai_building_token": "a13533e4-d0cb-11f0-a5ac-333ac8b0a02d",
  "custom_eliseai_organization_id": "ca6e7a0c-0871-4502-b699-60d5f5cfcb57",
  "custom_eliseai_tour_scheduler_url": "https://app.meetelise.com/ca6e7a0c-0871-4502-b699-60d5f5cfcb57/a13533e4-d0cb-11f0-a5ac-333ac8b0a02d/tour",
  "custom_apartmentsync_javascript_id": "eyJpdiI6InIwZGZEcTVsL1hyTUtWaTNENHhyQmc9PSIsInZhbHVlIjoibHhnMzlvMFhLUWF5cHZXbnJnNmgxUT09IiwibWFjIjoiYjdhZjliNzgyYWEzYWJiODg5MDlkYzBkOGQwMjA4ZWM2NmQyMzE4MjZjMjE5ZDc3ZTExMjhjYmM5MjhiZmFmOSJ9",
  "custom_audioeye_site_id": "b4fe70a8-eebe-4932-bfe2-afcb90fe5bae",
  "custom_audioeye_site_hash": "c5eca97a7eac0c5fc0ccb000aa54d2d8"
};

export const generatedAt = '2026-10-01T17:24:20.568Z';
